/**
 * @file index.tsx
 *
 * @fileoverview Shows a placeholder when a search form is loading.
 */

import React from "react";
import ContentLoader from "react-content-loader";
import HideDesktop from "../../../02-atoms/06-layout/02-visibility/01-hide-desktop";
import HideMobile from "../../../02-atoms/06-layout/02-visibility/02-hide-mobile";

/**
 * Placeholder skeleton for forms for when page is loading.
 */
export const SearchFormPlaceholder = () => (
  <>
    <HideMobile>
      <ContentLoader uniqueKey="search-form-desktop" height={100} width={800}>
        <rect x="10" y="4" rx="0" ry="0" width="385" height="22" />
        <rect x="405" y="4" rx="0" ry="0" width="385" height="22" />
        <rect x="100" y="40" rx="0" ry="0" width="100" height="13" />
        <rect x="210" y="40" rx="0" ry="0" width="80" height="13" />
        <rect x="300" y="40" rx="0" ry="0" width="80" height="13" />
        <rect x="390" y="40" rx="0" ry="0" width="100" height="13" />
        <rect x="500" y="40" rx="0" ry="0" width="150" height="13" />
      </ContentLoader>
    </HideMobile>
    <HideDesktop>
      <ContentLoader uniqueKey="search-form-mobile" height={100} width={300}>
        <rect x="0" y="4" rx="0" ry="0" width="300" height="20" />
        <rect x="0" y="30" rx="0" ry="0" width="300" height="20" />
        <rect x="100" y="60" rx="0" ry="0" width="100" height="20" />
      </ContentLoader>
    </HideDesktop>
  </>
);

export default SearchFormPlaceholder;
